import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Download",
  "use": "svg-icon-Download-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Download\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.8 1.8v4.221l.777-.777a.833.833 0 1 1 1.179 1.179L6.998 8.18c-.333.333-.673.473-.998.473-.325 0-.669-.143-1.003-.478L3.244 6.423a.833.833 0 1 1 1.179-1.179l.777.777V1.8a.8.8 0 1 1 1.6 0zM2.75 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol